import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/afiliacion",
    component: MasterLayout,
    children: [
      {
        path: "nueva",
        name: "afiliacion.nueva",
        component: () => import("@/views/afiliacion/nueva/index.vue")
      },
      {
        path: "pendientes",
        name: "afiliacion.pendientes",
        component: () => import("@/views/afiliacion/pendientes/index.vue")
      },
      {
        path: "inclusiones",
        name: "afiliacion.inclusiones",
        component: () => import("@/views/afiliacion/inclusiones/index.vue")
      },
      {
        path: "servicios",
        name: "afiliacion.servicios",
        component: () => import("@/views/afiliacion/servicios/index.vue")
      },
      {
        path: "documentos",
        name: "afiliacion.documentos",
        component: () => import("@/views/afiliacion/documentos/index.vue")
      },
      {
        path: "registros",
        name: "afiliacion.registros",
        component: () => import("@/views/afiliacion/registros/index.vue")
      },
      {
        path: "descargar",
        name: "afiliacion.descargar",
        component: () => import("@/views/afiliacion/descargar/index.vue")
      },
    ]
  }
]